// extracted by mini-css-extract-plugin
module.exports = {"labelsHolder":"ConfiguratorHeader_labelsHolder__19B-Y"};